import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { SortableContainer } from 'react-sortable-hoc';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import Skeleton from '@quintoandar/cozy-core/Skeleton';

import {
  makeSelectHasFinishedFetchPhotos,
  makeSelectPhotoHasFinishedUplaod,
  makeSelectPhotoHasStartedUplaod,
} from 'containers/PhotosManager/selectors';

import PhotosGalleryCardItem from './PhotosManagerCardItem';
import { BoxWrapper } from './elements';

export const PhotosManagerCardsWrapper = ({
  houseId,
  galleryType,
  photos,
  hasStartedPhotoUpload,
  hasFinishedPhotoUpload,
  hasFinishedFetchPhotos,
  propertyId,
  isDragging,
}) => (
  <BoxWrapper mt={4} mx="auto" maxWidth={{ xs: 360, sm: 'none' }}>
    {photos.map((photo, i) => (
      <PhotosGalleryCardItem
        houseId={houseId}
        galleryType={galleryType}
        index={i}
        key={photo.id}
        path={photo.path}
        previewPath={photo.pathPreview}
        description={photo.description}
        id={photo.id}
        isPrincipal={photo.isPrincipal}
        propertyId={propertyId}
        isDragging={isDragging}
        data-testid="photosphere-card-item"
      />
    ))}
    {hasStartedPhotoUpload &&
      !hasFinishedPhotoUpload &&
      hasFinishedFetchPhotos && <Skeleton maxHeight="100%" height="207px" />}
  </BoxWrapper>
);

PhotosManagerCardsWrapper.propTypes = {
  houseId: PropTypes.string,
  galleryType: PropTypes.string,
  photos: PropTypes.array,
  hasStartedPhotoUpload: PropTypes.bool,
  hasFinishedPhotoUpload: PropTypes.bool,
  hasFinishedFetchPhotos: PropTypes.bool,
  propertyId: PropTypes.string,
  isDragging: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  hasStartedPhotoUpload: makeSelectPhotoHasStartedUplaod(),
  hasFinishedPhotoUpload: makeSelectPhotoHasFinishedUplaod(),
  hasFinishedFetchPhotos: makeSelectHasFinishedFetchPhotos(),
});

const withConnect = connect(
  mapStateToProps,
  null,
);

export default compose(
  SortableContainer,
  withConnect,
)(PhotosManagerCardsWrapper);
